module.exports = __webpack_public_path__ + "img/slide6.bfdabeed.jpeg";